import React from "react";
import Styled from "./index.style";

const TextCommon = ({ children, ...restProps }) => {
  return <Styled {...restProps}>{children}</Styled>;
};

export default TextCommon;
